import { create } from 'zustand'

export type TabId = 'lighting' | 'material' | 'decals' | 'dashboard' | 'poi' | 'postprocess'

interface UnifiedPanelState {
  isOpen: boolean
  activeTab: TabId

  openPanel: (tab?: TabId) => void
  closePanel: () => void
  setActiveTab: (tab: TabId) => void
  togglePanel: () => void
}

export const useUnifiedPanelStore = create<UnifiedPanelState>((set) => ({
  isOpen: false,
  activeTab: 'lighting',

  openPanel: (tab) =>
    set((s) => ({
      isOpen: true,
      activeTab: tab ?? s.activeTab,
    })),

  closePanel: () => set({ isOpen: false }),

  setActiveTab: (tab) => set({ activeTab: tab }),

  togglePanel: () => set((s) => ({ isOpen: !s.isOpen })),
}))
